var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 7V2.83333H4.5V5.42C6.38 3.285 9.10333 2 12 2C17.5142 2 22 6.48583 22 12H20.3333C20.3333 7.405 16.595 3.66667 12 3.66667C9.37167 3.66667 6.90417 4.925 5.34083 7H8.66667V8.66667H4.5C3.58083 8.66667 2.83333 7.91917 2.83333 7ZM19.5 15.3333H15.3333V17H18.6592C17.095 19.075 14.6283 20.3333 12 20.3333C7.405 20.3333 3.66667 16.595 3.66667 12H2C2 17.5142 6.48583 22 12 22C14.8967 22 17.62 20.715 19.5 18.58V21.1667H21.1667V17C21.1667 16.0808 20.4192 15.3333 19.5 15.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.c1abcba40cdb8a612d414cd47395e19c.svg";
export { ForwardRef as ReactComponent };